.form {
  display: var(--haus-CustomerDetails__form__display, flex);
  flex-direction: var(--haus-CustomerDetails__form__flex-direction, column);
  justify-content: var(--haus-CustomerDetails__form__justify-content, center);
  align-items: var(--haus-CustomerDetails__form__align-items, stretch);
  gap: var(--haus-CustomerDetails__form__gap, 32px);
}

.formSection {
  display: var(--haus-CustomerDetails__formSection__display, flex);
  flex-direction: var(--haus-CustomerDetails__formSection__flex-direction, column);
  gap: var(--haus-CustomerDetails__formSection__gap, 16px);
}

.inputRow {
  display: var(--haus-CustomerDetails__inputRow__display, flex);
  align-items: var(--haus-CustomerDetails__inputRow__align-items, flex-start);
  gap: var(--haus-CustomerDetails__inputRow__gap, 16px);
  flex-wrap: var(--haus-CustomerDetails__inputRow__flex-wrap, wrap);

  @include bp.mobile-max {
    flex-direction: var(--haus-CustomerDetails__inputRow__mobile__flex-direction, column);

    > * {
      width: var(--haus-CustomerDetails__inputRow__mobile-field__width, 100%) !important;
      flex: var(--haus-CustomerDetails__inputRow__mobile-field__flex, 1 1 100%) !important;
      min-width: var(--haus-CustomerDetails__inputRow__mobile-field__min-width, 100%);
    }
  }

  @include bp.tablet-min {
    flex-wrap: var(--haus-CustomerDetails__inputRow__tablet__flex-wrap, nowrap);
  }
}

.checkboxRow {
  display: var(--haus-CustomerDetails__checkboxRow__display, inline-flex);
  align-items: var(--haus-CustomerDetails__checkboxRow__align-items, center);
  gap: var(--haus-CustomerDetails__checkboxRow__gap, 8px);
}

.buttonRow {
  display: var(--haus-CustomerDetails__buttonRow__display, flex);
  justify-content: var(--haus-CustomerDetails__buttonRow__justify-content, flex-start);
  align-items: var(--haus-CustomerDetails__buttonRow__align-items, flex-start);
  gap: var(--haus-CustomerDetails__buttonRow__gap, 16px);
}

.addressReadOnly {
  padding: var(--haus-CustomerDetails__addressReadOnly__padding, 12px 16px);
  border-radius: var(--haus-CustomerDetails__addressReadOnly__border-radius, 4px);
  background-color: var(--haus-CustomerDetails__addressReadOnly__background-color, none);
  border: var(--haus-CustomerDetails__addressReadOnly__border, 1px solid #0000001a);
  white-space: var(--haus-CustomerDetails__addressReadOnly__white-space, pre-line);
  margin: var(--haus-CustomerDetails__addressReadOnly__margin, 0);
  font-family: var(
    --haus-CustomerDetails__addressReadOnly__font-family,
    var(--haus-typography-body-font-family)
  );
  font-weight: var(
    --haus-CustomerDetails__addressReadOnly__font-weight,
    var(--haus-typography-body-font-weight)
  );
  font-style: var(
    --haus-CustomerDetails__addressReadOnly__font-style,
    var(--haus-typography-body-font-style)
  );
  font-size: var(
    --haus-CustomerDetails__addressReadOnly__font-size,
    var(--haus-typography-body-font-size)
  );
  line-height: var(
    --haus-CustomerDetails__addressReadOnly__line-height,
    var(--haus-typography-body-line-height)
  );
  color: var(--haus-CustomerDetails__addressReadOnly__color, var(--haus-typography-body-color));
}

.error {
  padding: var(--haus-customerDetails__error__padding, var(--haus-spacing-sm, 8px));
  border-radius: var(--haus-customerDetails__error__border-radius, 4px);
  font-size: var(--haus-customerDetails__error__font-size, 0.875rem);
  font-weight: var(--haus-customerDetails__error__font-weight, 400);
  line-height: var(--haus-customerDetails__error__line-height, 1.5);
  color: var(--haus-customerDetails__error__color, #972626);
  background-color: var(--haus-customerDetails__error__background-color, #ffd9d9);
  border: var(--haus-customerDetails__error__border, 1px solid #ffd9d9);
}
